export default __webpack_public_path__ + "static/media/poor1.294bf550.svg";